const GST_RATE = 0.18;
const PLATFORM_FEE_RATE = 0.02;

export function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

/**
 * Payable on a pre-tax service amount (wallet credit / plan / addon / credits).
 * GST 18% on base + platform fee 2% on base + GST 18% on that fee.
 */
export function computePayable(baseAmount) {
  const base = round2(baseAmount);
  if (!Number.isFinite(base) || base <= 0) {
    return {
      base: 0,
      gstOnBase: 0,
      platformFee: 0,
      gstOnFee: 0,
      gstTotal: 0,
      taxable: 0,
      total: 0,
    };
  }
  const gstOnBase = round2(base * GST_RATE);
  const platformFee = round2(base * PLATFORM_FEE_RATE);
  const gstOnFee = round2(platformFee * GST_RATE);
  const gstTotal = round2(gstOnBase + gstOnFee);
  const taxable = round2(base + platformFee);
  const total = round2(base + gstOnBase + platformFee + gstOnFee);
  return { base, gstOnBase, platformFee, gstOnFee, gstTotal, taxable, total };
}

export function formatChargeINR(n) {
  return Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPayable(baseAmount) {
  return formatChargeINR(computePayable(baseAmount).total);
}
